// extracted by mini-css-extract-plugin
export default {"lower_header":"LowerHeader_lower_header__Lc-mG","nav_list":"LowerHeader_nav_list__aeN5p","nav_item":"LowerHeader_nav_item__9LEMQ"};